import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// The company's name: the sidebar's role line and page eyebrows. GET /auth/me carries it for everyone; founders read
// it from GET /api/settings (theirs), so a rename in Settings shows at once.
export function useCompanyName() {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["settings"], enabled: user?.role === "owner", staleTime: 300000,
    queryFn: async () => (await api.get("/settings")).data,
  });
  return data?.company?.name || user?.company_name || "";
}

// A budget alert that is about the current period: a daily budget's today, a monthly one's this month (UTC, as the
// backend keys them). Objective alerts have no period; session caps are the independent professional's own.
export function currentAlert(a, now = new Date()) {
  if (a.scope === "session") return false;
  const period = a.key.split(":")[2];
  if (!period) return true;
  const iso = now.toISOString();
  const month = iso.slice(0, 4) + iso.slice(5, 7);
  return period === (period.length === 8 ? month + iso.slice(8, 10) : month);
}
